import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import { addToCart } from "../../features/cart/cartActions";
import { useMutation } from "@tanstack/react-query";
import { requestOTP, submitPrescription } from "../../services/products";
import { toast } from "sonner";
import { AlertComponent } from "./AlertComponent";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";

function PrescriptionModal({
  isPrescriptionModal,
  handlePrescriptionModal,
  // selectedProduct,
}) {
  // const dispatch = useDispatch();

  const { user = {} } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    PrescriptionFile: null,
    PrescriptionNotes: "",
    Notes: "",
    // Phone: user?.phoneNumber ?? "",
    // cellphoneNumber: user?.phoneNumber ?? "",
    Phone: user?.phoneNumber ?? "",
    cellphoneNumber: user?.phoneNumber ?? "",
    Email: user?.email ?? "",
    Username: `${user?.firstName}${user?.lastName}`,
    //
    CustomerId: user?.id,
    NationalIdOrPatientNumber: "",
    InsuranceNumber: "",
    PatientDateOfBirth: new Date(),
    OtpChannel: "0",
    Channel: "0",
    VerificationCode: "",
    DoctorName: "",
    DoctorId: "",
    IssueDate: new Date(),
    ExpiryDate: new Date(),
  });
  const [isVerified, setIsVerified] = useState(false);

  const [errorArray, setErrorArray] = useState([]);

  // const [preview, setPreview] = useState(null);
  const [retryTimer, setRetryTimer] = useState(0);
  const [canRetryVerification, setCanRetryVerification] = useState(true);

  useEffect(() => {
    if (retryTimer <= 0) {
      setCanRetryVerification(true);
      return;
    }

    const timer = setTimeout(() => {
      setRetryTimer((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [retryTimer]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file selection + preview
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Validate file type
    // if (file.type !== "application/pdf") {
    //   alert("Only PDF files are allowed");
    //   e.target.value = null; // reset input
    //   return;
    // }

    setFormData((prev) => ({
      ...prev,
      PrescriptionFile: file,
    }));

    // Preview only for images
    // if (file.type.startsWith("image/")) {
    //   const fileURL = URL.createObjectURL(file);
    //   setPreview(fileURL);
    // } else {
    //   setPreview(file.name);
    // }
  };

  // Submit handler
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!formData.PrescriptionFile) {
  //     alert("Please upload a prescription file");
  //     return;
  //   }

  //   // const data = new FormData();
  //   // data.append("PrescriptionFile", formData.PrescriptionFile);
  //   // data.append("PrescriptionNotes", formData.PrescriptionNotes);
  //   // data.append("phone", formData.phone);

  //   // Example API call
  //   console.log("Submitting...", {
  //     ...selectedProduct,
  //     quantity: 1,
  //     ...formData,
  //   });

  //   dispatch(addToCart({ ...selectedProduct, quantity: 1, ...formData }));

  //   // await uploadPrescriptionAPI(data)

  //   // handlePrescriptionModal(); // close modal after submit
  // };

  const { mutate: uploadPrescription, isPending } = useMutation({
    mutationFn: submitPrescription,
    onSuccess: (data) => {
      toast.success("Prescription uploaded successfully.");
      setIsVerified(false);
      setErrorArray([]);
      handlePrescriptionModal();
    },
    onError: (err) => {
      let error = [];
      error.push(err?.message ?? err);
      setErrorArray(error);
      toast.error(error || "Unable to upload prescription.");
    },
  });
  const { mutate: handleOtp, isPending: isLoading } = useMutation({
    mutationFn: requestOTP,
    onSuccess: (data) => {
      toast.success("OTP sent to the entered Email.");
      setIsVerified(true);
      setErrorArray([]);
      // handlePrescriptionModal();
    },
    onError: (err) => {
      let error = [];
      error.push(err?.message ?? err);
      setErrorArray(error);
      toast.error(error || "Unable to request OTP.");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.PrescriptionFile) {
      alert("Please upload a prescription file");
      return;
    }

    uploadPrescription(formData);
  };

  const handleVerification = (e) => {
    if (e) e.preventDefault();

    if (!canRetryVerification) {
      toast.error(`Please wait ${retryTimer}s before retrying verification.`);
      return;
    }

    if (!formData.Email && !formData.cellphoneNumber) {
      toast.error("Please enter an email address or a phonenumber.");
      return;
    }

    setCanRetryVerification(false);
    setRetryTimer(120);

    const data = {
      email: formData.Email,
      cellphoneNumber: formData.cellphoneNumber,
      channel: Number(formData.Channel),
    };

    handleOtp(data);
  };

  const handleCancel = () => {
    setFormData({
      PrescriptionFile: null,
      PrescriptionNotes: "",
      Phone: user?.phoneNumber ?? "",
      cellphoneNumber: user?.phoneNumber ?? "",
      Email: user?.email ?? "",
      Username: `${user?.firstName}${user?.lastName}`,
      //
      Notes: "",
      CustomerId: user?.id,
      NationalIdOrPatientNumber: "",
      InsuranceNumber: "",
      PatientDateOfBirth: new Date(),
      OtpChannel: "0",
      Channel: "0",
      VerificationCode: "",
      DoctorId: "",
      DoctorName: "",
      IssueDate: new Date(),
      ExpiryDate: new Date(),
    });
    // setPreview(null);
    setIsVerified(false);
    handlePrescriptionModal();
  };

  return (
    <Modal
      show={isPrescriptionModal}
      onHide={handlePrescriptionModal}
      centered
      backdrop={"static"}
      scrollable
    >
      <Modal.Header>
        <h6 className="m-0">Upload Prescription</h6>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {Boolean(errorArray.length) && (
            <AlertComponent errorArray={errorArray} />
          )}
          {!isVerified ? (
            <form autoComplete="off" onSubmit={handleVerification}>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="Email"
                  value={formData.Email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone</label>
                <PhoneInput
                  country={"ke"}
                  inputClass="form-control form-control-sm"
                  value={formData.cellphoneNumber}
                  inputProps={{
                    name: "cellnumber",
                    required: true,
                  }}
                  inputStyle={{
                    width: "100%",
                    fontSize: "12px",
                    lineHeight: "1.5",
                    height: " calc(1.5em + 0.5rem + 2px)",
                  }}
                  id="cellnumber"
                  name="cellnumber"
                  masks={{ ke: "... ... ..." }}
                  // onChange={(phone) => this.setState({ phone })}
                />
                {/* <input
                  type="tel"
                  className="form-control"
                  name="cellphoneNumber"
                  value={formData.cellphoneNumber}
                  onChange={handleChange}
                  placeholder="e.g 0712345678"
                /> */}
              </div>
              <div className="mb-3">
                <label className="form-label">Notification Channel</label>
                <select
                  className="form-select form-select-sm"
                  name="Channel"
                  value={formData.Channel}
                  onChange={handleChange}
                >
                  <option selected>Open this select menu</option>
                  <option value="0">Email</option>
                  <option value="1">Phone</option>
                </select>
              </div>
              <hr />
              <div className="d-flex justify-content-end gap-10">
                {/* {!canRetryVerification ? (
                  <span className="text-center m-0">
                    Retry in {retryTimer}s
                  </span>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-main"
                    onClick={handleVerification}
                    disabled={isLoading}
                  >
                    Retry verification
                  </button>
                )} */}
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={isLoading || !canRetryVerification}
                >
                  {isLoading && (
                    <div
                      className="spinner-border spinner-border-sm me-5"
                      role="status"
                    ></div>
                  )}
                  Submit
                </button>
                <button
                  className="btn btn-sm btn-outline-main-two"
                  onClick={handleCancel}
                  disabled={isLoading}
                  type="button"
                >
                  Close
                </button>
              </div>
            </form>
          ) : (
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Verfication Code<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="VerificationCode"
                      value={formData.VerificationCode}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                {/* <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Issue Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="IssueDate"
                      value={formData.IssueDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div> */}
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Prescription File<span className="text-danger">*</span>
                </label>
                <div className="hstack gap-10">
                  <input
                    type="file"
                    id="formFile"
                    accept="application/*"
                    className="form-control"
                    onChange={handleFileChange}
                    required
                  />
                  {/* {preview && (
                    <div className="mb-3">
                      <label className="form-label">Preview</label>
                      <div>
                        <img
                          src={preview}
                          alt="preview"
                          style={{
                            maxWidth: "100%",
                            height: "150px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Full Patient Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Username"
                      value={formData.Username}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                {/* <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Patient D.O.B<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="PatientDateOfBirth"
                      value={formData.PatientDateOfBirth}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div> */}
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Email<span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="Email"
                      value={formData.Email}
                      onChange={handleChange}
                      disabled
                      required
                    />
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Phone<span className="text-danger">*</span>
                    </label>
                    <PhoneInput
                      country={"ke"}
                      value={formData.Phone}
                      inputClass="form-control form-control-sm"
                      inputProps={{
                        name: "cellnumber",
                        required: true,
                      }}
                      inputStyle={{
                        width: "100%",
                        fontSize: "12px",
                        lineHeight: "1.5",
                        height: " calc(1.5em + 0.5rem + 2px)",
                      }}
                      id="Phone"
                      name="Phone"
                      disabled
                      masks={{ ke: "... ... ..." }}
                      onChange={(phone) =>
                        setFormData((prevState) => ({
                          ...prevState,
                          Phone: phone,
                        }))
                      }
                    />
                    {/* <input
                      type="text"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="e.g 0712345678"
                    /> */}
                  </div>
                </div>
              </div>
              <hr />
              {/* <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      National ID/Patient No
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="NationalIdOrPatientNumber"
                      value={formData.NationalIdOrPatientNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">Insurance No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="InsuranceNumber"
                      value={formData.InsuranceNumber}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div> */}
              {/* <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Doctor Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="DoctorName"
                      value={formData.DoctorName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div> */}
              {/* <div className="mb-3">
                <label className="form-label">
                  Expiry Date<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="ExpiryDate"
                  value={formData.ExpiryDate}
                  onChange={handleChange}
                  required
                />
              </div> */}
              <div className="mb-3">
                <label className="form-label">Notification Channel</label>
                <select
                  className="form-select form-select-sm"
                  name="Channel"
                  value={formData.Channel}
                  onChange={handleChange}
                >
                  <option selected>Open this select menu</option>
                  <option value="0">Email</option>
                  <option value="1">Phone</option>
                </select>
              </div>
              <hr />
              <div className="d-flex justify-content-end gap-10">
                {!canRetryVerification ? (
                  <span className="text-center m-0">
                    Retry in {retryTimer}s
                  </span>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-main"
                    onClick={handleVerification}
                    disabled={isLoading}
                  >
                    Retry verification
                  </button>
                )}
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={isPending || isLoading}
                >
                  {(isPending || isLoading) && (
                    <div
                      className="spinner-border spinner-border-sm me-5"
                      role="status"
                    ></div>
                  )}
                  Submit
                </button>
                <button
                  className="btn btn-sm btn-outline-main-two"
                  onClick={handleCancel}
                  disabled={isPending || isLoading}
                  type="button"
                >
                  Close
                </button>
              </div>
            </form>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PrescriptionModal;
